import React, { FC, useState, useRef } from 'react'
import { IonContent, IonModal } from '@ionic/react'
import i18n from 'i18next'
import { UsernameInput } from '@cps'
import './index.scss'
interface IProps {
  reject?: any;
  resolve?: any;
}
const PhoneModal: FC<IProps> = ({ reject, resolve }) => {
  const [info, setInfo] = useState({
    type: 'mobile',
    value: '',
    valid: false,
    countryCode: bo === 'us' ? 1 : 86
  })

  const sendMsg = () => {
    info.valid && resolve(info)
  }
  return (
    <IonModal
      cssClass='phone-modal'
      isOpen
      showBackdrop
      onWillDismiss={() => reject()}
      backdropDismiss
    >
      <IonContent data-cypid='phoneModalClose' onClick={() => reject()}>
        <div className='content-wrap' onClick={(e) => e.stopPropagation()}>
          <div className='title'>
            <i className='iconfont icon-send2x'></i>
            <span>{i18n.t('result.sendOrderTips')}</span>
          </div>
          <div className='content'>
            <div className='number-input'>
              <UsernameInput
                value={{
                  pass: info.value,
                  passType: info.type,
                  countryCode: info.countryCode,
                }}
                onChange={(data, valid) => {
                  setInfo({
                    type: data.passType,
                    value: data.pass,
                    countryCode: data.countryCode,
                    valid
                  })
                }}
              />
              <div className={info.value && info.valid ? 'checked' : ''} data-cypid='phoneModalSend' onClick={sendMsg}>{i18n.t('result.send')}</div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default PhoneModal
